import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PartnerLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = window.location.origin;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const r = await fetch(`${apiUrl}/api/v1/partner-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: form.email, password: form.password })
      });
      const data = await r.json();
      if (!r.ok) {
        setError(data.detail || 'Login failed');
        return;
      }
      localStorage.setItem('partner_token', data.token);
      localStorage.setItem('partner', JSON.stringify(data.partner));
      navigate('/partner-portal');
    } catch {
      setError('Cannot connect to server.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#5b9bd5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: "'Georgia', serif" }}>
      <div style={{ width: '100%', maxWidth: '420px', background: 'rgba(255,255,255,0.88)', borderRadius: '20px', padding: '40px 36px', boxShadow: '0 20px 60px rgba(30,58,95,0.18)' }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '28px' }}>
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="16" stroke="#059669" strokeWidth="2.5" fill="none"/><path d="M18 8 A10 10 0 1 1 8 18" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" fill="none"/><circle cx="18" cy="18" r="4" fill="#4f46e5"/></svg>
          <div>
            <div style={{ fontSize: '12px', fontWeight: '700', letterSpacing: '0.08em', color: '#1e3a5f' }}><span style={{color:'#4f46e5'}}>F</span><span style={{color:'#ef4444'}}>H</span><span style={{color:'#059669'}}>O</span> PLATFORM</div>
            <div style={{ fontSize: '10px', color: '#64748b', letterSpacing: '0.06em' }}>PARTNER PORTAL</div>
          </div>
        </div>

        <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#1e3a5f', margin: '0 0 6px' }}>Partner Sign In</h1>
        <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 24px' }}>Access your organization's FHO dashboard</p>

        {error && <div style={{ padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', color: '#991b1b', fontSize: '13px', marginBottom: '16px' }}>{error}</div>}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div>
            <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b', letterSpacing: '0.08em', textTransform: 'uppercase', display: 'block', marginBottom: '4px' }}>Email Address</label>
            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required disabled={isLoading}
              placeholder="you@organization.com"
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '1px solid rgba(30,58,95,0.2)', fontSize: '15px', color: '#1e3a5f', boxSizing: 'border-box', outline: 'none', fontFamily: "'Georgia', serif" }} />
          </div>
          <div>
            <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b', letterSpacing: '0.08em', textTransform: 'uppercase', display: 'block', marginBottom: '4px' }}>Password</label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required disabled={isLoading}
              placeholder="Your password"
              style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', border: '1px solid rgba(30,58,95,0.2)', fontSize: '15px', color: '#1e3a5f', boxSizing: 'border-box', outline: 'none', fontFamily: "'Georgia', serif" }} />
          </div>
          <button type="submit" disabled={isLoading}
            style={{ padding: '13px', background: '#4f46e5', border: 'none', borderRadius: '10px', color: '#fff', fontSize: '15px', fontWeight: '600', cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.7 : 1, fontFamily: "'Georgia', serif", marginTop: '6px' }}>
            {isLoading ? 'Signing in...' : 'Sign In to Partner Portal'}
          </button>
        </form>

        <p style={{ textAlign: 'center', fontSize: '12px', color: '#94a3b8', marginTop: '24px' }}>
          Need access? Email <a href="mailto:partnerships@freehappyone.com" style={{ color: '#4f46e5' }}>partnerships@freehappyone.com</a>
        </p>
      </div>
    </div>
  );
};

export default PartnerLogin;
